<template>
  <div class="step-selector">
    <div class="step-selector-trigger" @click="openDropdown">
      <div
        class="step-selector-dot"
        :style="{ backgroundColor: card.stepColor }"
      ></div>
      <span class="step-selector-name">{{ card.stepName }}</span>
      <i class="fa-solid fa-chevron-down step-selector-chevron"></i>
    </div>
    <div v-if="show" class="step-selector-dropdown" @mouseleave="show = false">
      <div
        v-for="item in steps"
        :key="item.id"
        class="step-selector-option"
        @click="selectStep(item)"
      >
        <div
          class="step-selector-dot"
          :style="{ backgroundColor: item.color }"
        ></div>
        <span class="step-selector-option-name">{{ item.content }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CardService from "../../services/card.service";
import { mapActions } from "vuex";

export default {
  name: "StepSelector",
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      steps: [],
      show: false,
    };
  },
  mounted() {
    this.loadSteps();
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    async openDropdown() {
      if (!this.steps.length) {
        await this.loadSteps();
      }
      this.show = true;
    },
    async loadSteps() {
      const funnelId = (this.$route.params && this.$route.params.id) || this.card.frameId || this.card.funnelId || "";
      const params = {
        url: "/api/v1/planner/step/select-all",
        obj: { search: "", currentPage: 1, totalPerPage: 50, any: funnelId },
      };
      const response = await this.getApi(params);
      const data = response && response.content && response.content.data
        ? response.content.data
        : [];
      this.steps = data.map((item) => ({
        ...item,
        content: item.content || item.name || item.text || "",
      }));
    },
    async selectStep(step) {
      this.show = false;
      await CardService.moveToStep(this.card.id, step.id);
      this.card.stepName = step.content;
      this.card.stepColor = step.color;
    },
  },
};
</script>

<style scoped>
.step-selector {
  position: relative;
  display: inline-block;
}

.step-selector-trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 50px;
  border: 1px solid var(--border-color);
  background: var(--bg-base);
  transition: background 0.15s, border-color 0.15s;
}

.step-selector-trigger:hover {
  background: var(--bg-hover);
  border-color: var(--border-subtle);
}

.step-selector-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  flex-shrink: 0;
}

.step-selector-name {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-primary);
}

.step-selector-chevron {
  font-size: 10px;
  color: var(--text-muted);
}

.step-selector-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 200px;
  background: var(--bg-base);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 8px;
  z-index: 1000;
  box-shadow: var(--shadow-lg);
}

.step-selector-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.step-selector-option:hover {
  background: var(--bg-hover);
}

.step-selector-option-name {
  font-size: 12px;
  color: var(--text-primary);
}
</style>
